<template>
  <v-container class="margen_paginas pt-7">
    <v-card max-width="240px" style="background: rgba(180, 180, 180, 0.85);">
      <div class="text-h5 mb-4 d-flex align-center pa-1">
        <v-icon large class="mr-1">mdi-home</v-icon>
        {{$t ('Inicio')}}
      </div>
    </v-card>

    <!--
    <TarjetaResumen icono="mdi-card-account-details-outline" color="#40AF90" :valor="estadisticasEmpresaInquilina.numero_total_pases">{{ $t ('Total de pases') }}</TarjetaResumen>
    <TarjetaResumen v-if="estadisticasEmpresaInquilina.empresa_inquilina" icono="mdi-chart-line" color="#4090AF" :valor="estadisticasEmpresaInquilina.total_plazas_ocupadas + ' / ' + estadisticasEmpresaInquilina.empresa_inquilina.platot">{{ $t ('Total de plazas ocupadas') }}</TarjetaResumen>
    <TarjetaResumen v-else icono="mdi-chart-line" color="#4090AF" :valor="estadisticasEmpresaInquilina.total_plazas_ocupadas">{{ $t ('Total de plazas ocupadas') }}</TarjetaResumen>
    <TarjetaResumen v-if="$parametros_configuracion.modres" icono="mdi-calendar-check" color="#AF4090" :valor="estadisticasEmpresaInquilina.total_reservas_usadas_hoy + ' / ' + estadisticasEmpresaInquilina.total_reservas_hoy">{{ $t ('Reservas utilizadas (hoy)') }}</TarjetaResumen>
    <TarjetaResumen icono="mdi-swap-horizontal-bold" color="#9575CD" :valor="estadisticasEmpresaInquilina.numero_accesos_hoy">{{ $t ('Accesos (hoy)') }}</TarjetaResumen>
    <TarjetaResumen icono="mdi-alert" color="#FF8A65" :valor="estadisticasEmpresaInquilina.numero_incidencias_hoy">{{ $t ('Incidencias (hoy)') }} </TarjetaResumen>
    -->

  </v-container>
</template>

<script>
//import TarjetaResumen from '@/components/TarjetaResumen.vue'

export default {
  components: {
                // TarjetaResumen
              },
  methods: {
  },
}
</script>

<style>
</style>